import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { LoginService } from './service/login.service';
import { PatronGuard } from './patron.guard';
import { AppComponent } from './app.component';
import { Observable } from './classes/observable';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard implements CanActivate {
  constructor(public login: LoginService, public router: Router, public patronGuard: PatronGuard) {

  }
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) {
    var resp: any = false;
    if(AppComponent.inError){
      return true;
    }
    Observable.suscribe("error_token",(data)=>{
        this.borrar_data();
        Observable.unsuscribe("error_token");
    });
    await this.login.checkToken("api/checkToken", { token: localStorage.getItem("token") }).then(data => {
      resp = true;
      localStorage.removeItem("onboarding");
      AppComponent.login=true;
      return true;
    }).catch(data => {
      Observable.notify("error_token","");
      resp = false;
      return false
    });
    return resp;
  }

  borrar_data(){
    localStorage.removeItem("token");
      this.router.navigateByUrl("welcome");
      let varsOnboarding = localStorage.getItem("varsOnboarding");
      let onboardingLastPage = localStorage.getItem("onboardingLastPage");
      let validaciones = localStorage.getItem("validaciones");
      let onboarding= localStorage.getItem("onboarding");
      let proceso_alta= localStorage.getItem("proceso_alta");

      localStorage.clear();

      localStorage.setItem("varsOnboarding",varsOnboarding);
      localStorage.setItem("onboardingLastPage",onboardingLastPage);
      localStorage.setItem("validaciones",validaciones);
      localStorage.setItem("onboarding",onboarding);
      localStorage.setItem("proceso_alta",proceso_alta);
      
      AppComponent.login=false;      
  }
}
